import React from "react";
import LoadingLottieAnimation from "../../../components/app-specific/lottie-animations/loading";

const PartnerDataGridLoadingComponent = () => {

    return (
        <>
            <LoadingLottieAnimation width={'min(400px, 90%)'}/>
        </>
    )
}

export default PartnerDataGridLoadingComponent;
